
import { formatDateTimeToBR } from "../../Utils/DataFormatters";
import { FaRegCopy } from "react-icons/fa";
import { toast } from "react-toastify";
import Button from "../Button/Button";

type BankingBilletStepProps = {
  billetUrl: string;
  billetPdf: string;
  expiration: string;
};

const BankingBilletStep = ({ billetUrl, billetPdf, expiration }: BankingBilletStepProps) => {

  const handleCopyLink = () => {
    navigator.clipboard.writeText(billetUrl);
    toast.success("Link do boleto copiado!");
  };

  const formattedExpiration = formatDateTimeToBR(expiration);

  return (
    <div className="flex flex-col items-center text-center w-full max-w-4xl mx-auto p-4 md:p-6 gap-3">
      <h2 className="text-xl font-bold text-primary-600">{"Boleto Bancário"}</h2>
      <p className="text-sm md:text-base mb-4">
        {"Você pode visualizar ou baixar seu boleto clicando no link abaixo:"}
      </p>
      <div className="flex flex-col gap-1 mb-1">
        <a
          href={billetUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary-600 underline"
        >
          {"Abrir boleto"}
        </a>
        {billetPdf && (
          <a
            href={billetPdf}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 underline"
          >
            {"Abrir PDF do boleto"}
          </a>
        )}
      </div>
      <Button
        onClick={handleCopyLink}
        className="flex items-center gap-2 py-2 px-4"
      >
        <FaRegCopy />
        {"Copiar link do boleto"}
      </Button>
      <p className="text-xs md:text-sm text-gray-600 mt-2">
        {"Vencimento em"}: {formattedExpiration}
      </p>
      <p className="text-xs md:text-sm text-gray-600">
        {"Realize o pagamento até o vencimento para evitar o cancelamento automático do pedido."}
      </p>
    </div>
  );
};

export default BankingBilletStep;
